import { Breadcrumb } from 'record-it-components/context/BreadcrumbsContext';
import { iconConfigurations } from '../../icon/iconConfigurations';
import { RoutePaths } from '../../RoutePaths/RoutePaths';

export class BreadcrumbsBuilder {
  private breadcrumbs: Array<Breadcrumb> = [];

  public addHomePage(): this {
    return this.add({
      ...iconConfigurations.prefixed.page.HomePage.titleIcon,
      to: RoutePaths.home()
    });
  }

  public addCreateWorkTimeEntryPage(): this {
    return this.add({
      ...iconConfigurations.prefixed.page.CreateWorkTimeEntryPage.titleIcon,
      to: RoutePaths.createWorkTimeEntry()
    });
  }

  public addCreateWorkTimeEntrySelectActivityPage(
    parentActivityId: string | null
  ): this {
    return this.add({
      ...iconConfigurations.prefixed.page.CreateWorkTimeEntrySelectActivityPage
        .titleIcon,
      to: RoutePaths.createWorkTimeEntrySelectActivity(parentActivityId)
    });
  }

  public addCreateWorkTimeEntrySelectConstructionSitePage(): this {
    return this.add({
      ...iconConfigurations.prefixed.page
        .CreateWorkTimeEntrySelectConstructionSitePage.titleIcon,
      to: RoutePaths.createWorkTimeEntrySelectConstructionSite()
    });
  }

  public addCreateWorkTimeEntryCreateConstructionSitePage(): this {
    return this.add({
      ...iconConfigurations.prefixed.page.CreateConstructionSitePage.titleIcon,
      to: RoutePaths.createWorkTimeEntryCreateConstructionSite()
    });
  }

  public addMyWorkTimeOverviewPage(): this {
    return this.add({
      ...iconConfigurations.prefixed.page.MyWorkTimeOverviewPage.titleIcon,
      to: RoutePaths.myWorkTimeOverview()
    });
  }

  public addWorkTimeAdminPage(userGroupId: string, userId: string): this {
    return this.add({
      ...iconConfigurations.prefixed.page.WorkTimeAdminPage.titleIcon,
      to: RoutePaths.adminWorkTime(userGroupId, userId)
    });
  }

  public addEditWorkTimeEntryPage(workTimeEntryId: string): this {
    return this.add({
      ...iconConfigurations.prefixed.page.EditWorkTimeEntryPage.titleIcon,
      to: RoutePaths.editWorkTimeEntry(workTimeEntryId)
    });
  }

  public addConstructionSiteAdminPage(): this {
    return this.add({
      ...iconConfigurations.prefixed.page.ConstructionSiteAdminPage.titleIcon,
      to: RoutePaths.adminConstructionSites()
    });
  }

  public addConstructionSiteAdminCreateConstructionSitePage(
    userGroupId: string
  ): this {
    return this.add({
      ...iconConfigurations.prefixed.page.ConstructionSiteAdminPage.titleIcon,
      to: RoutePaths.adminConstructionSitesCreateConstructionSite(userGroupId)
    });
  }

  public addTimeTrackingActivityCompilationAdminPage(
    userGroupId: string
  ): this {
    return this.add({
      ...iconConfigurations.prefixed.page
        .TimeTrackingActivityCompilationAdminPage.titleIcon,
      to: RoutePaths.adminTimeTrackingActivityCompilations(userGroupId)
    });
  }

  public addTimeTrackingActivityAdminPage(
    timeTrackingActivityCompilationId: string,
    parentActivityId: string | null
  ): this {
    return this.add({
      ...iconConfigurations.prefixed.page.TimeTrackingActivityAdminPage
        .titleIcon,
      to: RoutePaths.adminTimeTrackingActivities(
        timeTrackingActivityCompilationId,
        parentActivityId
      )
    });
  }

  public addTimeTrackingConfigurationAdminPage(): this {
    return this.add({
      ...iconConfigurations.prefixed.page.TimeTrackingConfigurationAdminPage
        .titleIcon,
      to: RoutePaths.adminTimeTrackingConfigurations()
    });
  }

  public addUserAdminPage(): this {
    return this.add({
      ...iconConfigurations.prefixed.page.UserAdminPage.titleIcon,
      to: RoutePaths.adminUsers()
    });
  }

  public addUserGroupAdminPage(): this {
    return this.add({
      ...iconConfigurations.prefixed.page.UserGroupAdminPage.titleIcon,
      to: RoutePaths.adminUserGroups()
    });
  }

  public add(breadcrumb: BreadcrumbToAdd): this {
    this.breadcrumbs = [
      ...this.breadcrumbs,
      {
        disabled: false,
        ...breadcrumb
      }
    ];

    return this;
  }

  /**
   * disables the last added breadcrumb
   */
  public disable(): this {
    const lastIndex = this.breadcrumbs.length - 1;

    this.breadcrumbs = this.breadcrumbs.map((crumb, index) => {
      if (index !== lastIndex) {
        return crumb;
      }

      return {
        ...crumb,
        disabled: true
      };
    });

    return this;
  }

  public build(): Array<Breadcrumb> {
    return this.breadcrumbs;
  }
}

type BreadcrumbToAdd = Pick<Breadcrumb, 'iconName' | 'iconType' | 'to'> &
  Partial<Pick<Breadcrumb, 'disabled'>>;
